const html = require('choo/html')
const Button = require('../elements/button.js')
const PanelElement = require('../elements/panel.js')

module.exports = function ExportMenu (state, emit) {
  const exportButton = Button({
    text: 'Export',
    size: 'small',
    onClick: () => emit('export-project')
  })

  const importButton = Button({
    text: 'Import',
    size: 'small',
    onClick: () => emit('open-import-project-dialog')
  })

  const shareButton = Button({
    text: 'Share',
    size: 'medium',
    type: 'icon-aligned',
    color: 'pink',
    onClick: () => emit('share-project')
  })

  return PanelElement({
    color: 'purple',
    size: 'small',
    children: html`
      <div class="project-actions">
        ${shareButton}
        <div class="project-actions-row">
          ${importButton}
          ${exportButton}
        </div>
      </div>
    `
  })
} 